import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useMutation } from "@apollo/client/react";
import {
  ASSET_QUERY,
  GROUPED_ASSET_QUERY,
  RECALCULATE_ASSET_AVAILABLE_QUANTITY_MUTATION,
} from "src/constants/graphql";
import useNotification from "src/hooks/notification";

export default function RecalculateAvailableQuantityButton({ asset }) {
  const { notifyError, notifySuccess } = useNotification();

  const refetchQueries = asset?.type === "GroupedAsset"
    ? [{ query: GROUPED_ASSET_QUERY, variables: { id: asset.id } }]
    : [{ query: ASSET_QUERY, variables: { id: asset.id } }];

  const [recalculateAssetAvailableQuantity, { loading }] = useMutation(
    RECALCULATE_ASSET_AVAILABLE_QUANTITY_MUTATION
  );

  const handleClick = async () => {
    if (!asset?.id) return;

    try {
      const { data } = await recalculateAssetAvailableQuantity({
        variables: { assetId: asset.id },
        refetchQueries,
        awaitRefetchQueries: false,
      });

      const payload = data?.recalculateAssetAvailableQuantity;
      if (payload?.success) {
        notifySuccess("Recalculation queued. Quantities will refresh shortly.");
      } else {
        notifyError(payload?.errors || "Failed to queue recalculation.");
      }
    } catch (error) {
      notifyError(error.message || "Failed to queue recalculation.");
    }
  };

  return (
    <Tooltip title="Refresh available quantity">
      <span>
        <IconButton
          color="primary"
          onClick={handleClick}
          disabled={loading || !asset?.id}
          size="small"
          aria-label="Refresh available quantity"
        >
          {loading ? <CircularProgress color="inherit" size={18} /> : <RefreshIcon fontSize="small" />}
        </IconButton>
      </span>
    </Tooltip>
  );
}
